import classNames from 'classnames';
import { IconInfo } from 'featherico';
import type { ReactElement } from 'react';
import type { TooltipPosition } from '../Tooltip';
import Tooltip from '../Tooltip';
import styles from './style.m.less';

type Props = {
    tooltip: ReactElement | string | null;
    marginLeft?: boolean;
    className?: string;
    position?: TooltipPosition;
};

export default function TooltipInfoIcon({ tooltip, marginLeft = true, className, position }: Props) {
    return (
        <Tooltip
            tooltip={tooltip}
            className={classNames(className, styles.tooltipInfoIcon, { [styles.iconMargin]: marginLeft })}
            position={position}
        >
            <span aria-hidden="true">
                <IconInfo />
            </span>
        </Tooltip>
    );
}
